<template src="./IdentificationSelect.html" />
<style lang="scss" scoped src="./IdentificationSelect.scss"></style>
<script>
import { computed, defineComponent, ref } from '@vue/composition-api'
import useMe from '@/comporsables/useMe'
import HeaderRight from '@/compornents/HeaderRight/HeaderRight'
import AvatarImg from '@/compornents/AvatarImg/AvatarImg'
import Camera from '@/compornents/Camera'
import { ID_CHECKED_STATUS, LOADING_TYPE_ATTACH } from '@/constants/constant'
import { canPreview, getExt } from '@/utils/common'
import { createImage, isImage, toBlob } from '@/utils/image'
import {
  GET_USER_IDENTIFICATION,
  POST_USER_IDENTIFICATION,
  SET_LOADING
} from '@/store/types'
import { getNowFullString } from '@/utils/date'
import { putS3Attachment } from '@/comporsables/useAws'

export default defineComponent({
  name: 'IdentificationSelect',
  components: {
    HeaderRight,
    AvatarImg,
    Camera
  },
  title() {
    return '本人確認認証'
  },
  setup(_, { root }) {
    const { me } = useMe(root)
    const identificationStatus = computed(
      () => root.$store.getters.identificationStatus
    )
    const isSp = computed(() => root.$store.getters.isSp)
    if (
      ![
        ID_CHECKED_STATUS.UNAUTHENTICATED,
        ID_CHECKED_STATUS.DENIED,
        ID_CHECKED_STATUS.INCOMPLETE
      ].includes(identificationStatus.value)
    ) {
      root.$router.push({ name: 'identification' })
    }

    const showCameraMenu = ref(false)
    const showCameraNo = ref(0)
    const attachFile1 = ref('')
    const attachFile2 = ref('')
    const attachFile3 = ref('')
    const uploadFileData1 = ref('')
    const uploadFileData2 = ref('')
    const uploadFileData3 = ref('')
    const fileRef1 = ref(null)
    const fileRef2 = ref(null)
    const fileRef3 = ref(null)
    const inputFile = e => {
      const files = e.target.files || e.dataTransfer.files
      if (!isImage(getExt(files[0].name))) {
        root.$notify({
          title: '',
          message: '画像ファイルを選択してください',
          type: 'error'
        })
        switch (showCameraNo.value) {
          case 1:
            fileRef1.value.value = null
            break
          case 2:
            fileRef2.value.value = null
            break
          case 3:
            fileRef3.value.value = null
            break
        }
        return
      }
      showCameraMenu.value = false
      switch (showCameraNo.value) {
        case 1:
          attachFile1.value = files[0]
          createImage(attachFile1.value, uploadFileData1)
          break
        case 2:
          attachFile2.value = files[0]
          createImage(attachFile2.value, uploadFileData2)
          break
        case 3:
          attachFile3.value = files[0]
          createImage(attachFile3.value, uploadFileData3)
          break
      }
    }
    const canPreviewFile = no => {
      switch (no) {
        case 1:
          return attachFile1.value ? canPreview(attachFile1.value.name) : false
        case 2:
          return attachFile2.value ? canPreview(attachFile2.value.name) : false
        case 3:
          return attachFile3.value ? canPreview(attachFile3.value.name) : false
      }
    }

    const canUpload = computed(
      () =>
        uploadFileData1.value && uploadFileData2.value && uploadFileData3.value
    )
    const upload = () => {
      root.$store.dispatch(SET_LOADING, {
        type: LOADING_TYPE_ATTACH,
        status: true
      })

      const attachFileKey1 = `identification-${
        me.user_id
      }/${getNowFullString()}_${attachFile1.value.name}`
      const attachFileKey2 = `identification-${
        me.user_id
      }/${getNowFullString()}_${attachFile2.value.name}`
      const attachFileKey3 = `identification-${
        me.user_id
      }/${getNowFullString()}_${attachFile3.value.name}`

      Promise.all([
        putS3Attachment(
          attachFileKey1,
          toBlob(uploadFileData1.value, attachFile1.value.type),
          attachFile1.value.type
        ),
        putS3Attachment(
          attachFileKey2,
          toBlob(uploadFileData2.value, attachFile2.value.type),
          attachFile2.value.type
        ),
        putS3Attachment(
          attachFileKey3,
          toBlob(uploadFileData3.value, attachFile3.value.type),
          attachFile2.value.type
        )
      ])
        .then(() => {
          root.$store
            .dispatch(POST_USER_IDENTIFICATION, {
              identity_image_front_side_url: attachFileKey1,
              identity_image_back_side_url: attachFileKey2,
              identity_image_face_photo_url: attachFileKey3
            })
            .then(() => {
              root.$store.dispatch(GET_USER_IDENTIFICATION).then(() => {
                showCameraMenu.value = false
                root.$store.dispatch(SET_LOADING, {
                  type: LOADING_TYPE_ATTACH,
                  status: false
                })
                root.$router.push({ name: 'identification' })
              })
            })
        })
        .catch(err => {
          console.log(err)
          root.$notify({
            title: '',
            message: 'ファイルのアップロードに失敗しました',
            type: 'error'
          })
        })
    }

    const clearFile = no => {
      switch (no) {
        case 1:
          attachFile1.value = ''
          uploadFileData1.value = ''
          fileRef1.value.value = null
          break
        case 2:
          attachFile2.value = ''
          uploadFileData2.value = ''
          fileRef2.value.value = null
          break
        case 3:
          attachFile3.value = ''
          uploadFileData3.value = ''
          fileRef3.value.value = null
      }
    }

    return {
      loading: computed(() => root.$store.getters.loading),
      me,
      isSp,
      ID_CHECKED_STATUS,
      inputFile,
      showCameraNo,
      canPreviewFile,
      uploadFileData1,
      uploadFileData2,
      uploadFileData3,
      showCameraMenu,
      attachFile1,
      attachFile2,
      attachFile3,
      upload,
      canUpload,
      clearFile,
      fileRef1,
      fileRef2,
      fileRef3
    }
  }
})
</script>
